/* eslint-disable */
export default {
  callerCall: 'Interlocutor',
  transferCall: 'Transferir',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
